import { red } from "@material-ui/core/colors";
import { unstable_createMuiStrictModeTheme as createMuiTheme } from "@material-ui/core/styles";
import { defaultTheme } from "./emotion-theme";

// A custom theme for this app
const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#00CAFF",
    },
    secondary: {
      main: "#1E8549",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#fefefe",
    },
    success: {
      main: "#1E8549",
    },
  },
  typography: {
    fontFamily: defaultTheme.fontFamily.primary,
    button: {
      textTransform: "none",
    },
  },
});

export default theme;
